'use strict';

angular.module('substoreApp.controllers')
    .controller('ordersummaryController', OrdersummaryController);

function OrdersummaryController($scope, $routeParams, $window, dialogData, uiservice, sessionData, productDataCollector, optinProductTransformer, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.mode = { optin: ($routeParams.mode === "optin") ? true : undefined };

    sessionData.transient.subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    sessionData.transient.orderCallId = $routeParams.orderCallId;

    $scope.isCatalogueActive = true;
    $scope.nextClicked = false;

    $scope.progressBar.reset();

    $scope.confirmation = orderProductTermsConfirmation();

    $scope.actions = {
        next: function () {
            if ($scope.nextClicked)
                return;
            if ($scope.confirmation.failed(
                $scope.data.product.hyperlinks.termsOrderLinkUrl,
                $scope.data.product.hyperlinks.rescissionOrderLinkUrl,
                $scope.data.product.textLists.textToBeConfirmedSummary,
                $scope.data.product.textLists.textToBeConfirmedChangeSummary,
                $scope.data.product.texts.emailTextProductOrder))
                return;
            $scope.nextClicked = true;
            $scope.data.subscriptionBookWorkflowWasInvoked = true;
            uiservice.subscriptionBook({
                    sessionId: sessionData.sessionId,
                    orderCallId: orderCallId,
                    subscriptionTemplateId: $scope.data.product.subscriptionTemplateId,
                    acceptTerms: $scope.confirmation.ok.acceptTerms,
                    acceptRescissionRights: $scope.confirmation.ok.acceptRescissionRights,
                    customerEmail: $scope.confirmation.customerEmail,
                    optin: $scope.mode.optin
                },
                function success(response) {
                    if (sessionData.dialogStaticData.enableWebtrekkIntegration && response.data != null) {
                        // remember price and uniqueSubscriptionId for order confirmation dialog
                        sessionData.transient.priceValue = response.data.priceValue;
                        sessionData.transient.uniqueSubscriptionId = response.data.uniqueSubscriptionId;
                    }

                    var url = "/orderconfirmation/" + $scope.data.product.subscriptionTemplateId;
                    if ($scope.mode.optin)
                        url = url + "/optin";
                    else if (response.data != null && response.data.confirmationInProgress != null && response.data.confirmationInProgress) {
                        url = url + "/inProgress";
                    }
                    $scope.go(url);
                },
                $scope.throwServiceResponseFault
            );
        },
        cancel: function () {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            uiservice.subscriptionCancel({sessionId: sessionData.sessionId});
            sessionData.deleteCurrentSubscription();
            $scope.cancel($scope.data.subscriptionBookedByExtern || $scope.mode.optin);
        },
        changeUser: function () {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            if ($scope.data.logoutURL) {
                // CAP-1587: don't forget authentication data if we redirect to a 3rd-party URL
                $window.location.href = $scope.data.logoutURL;
            } else {
                uiservice.forgetAuthentication({ sessionId: sessionData.sessionId },
                    function success(response) {
                        if ($scope.data.partnerName === "Spotify" && $scope.data.authenticationURL){
                            $window.location.href = $scope.data.authenticationURL;
                        } else {
                            $scope.go("/orderselection/" + $scope.data.product.subscriptionTemplateId);
                        }

                    },
                    $scope.throwServiceResponseFault
                );
            }
        }
    };

    // we do grab the following items to avoid let global routing rules wipe them out before we can cancel subscription
    var orderCallId = sessionData.transient.orderCallId;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = optinProductTransformer.transform(productDataCollector.collect(data.product),'Optin');

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        $scope.updateTeaser(
            product.texts.headerTitleSummary,
            product.texts.headerSubTitleSummary,
            product.images.headerImageSummaryResourcePath);

        $scope.progressBar.setup({
            step: 2,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled,
            optin: $scope.mode.optin,
            hideSelection: dialogData.orderSelectionSkipped
        });

        $scope.data = data;

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        $scope.confirmation.customerEmail = $scope.confirmation.customerVerificationEmail = (product.texts.emailTextProductOrder ? data.customerEmail : null);
        $scope.confirmation.emailVerification = dialogData.emailVerification;

        webtrekk.track('order_summary', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: "1",
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    initDialogData();
}
